<template>
  <div
    class="flex items-center justify-center w-full min-h-screen min-w-screen"
  >
    <div
      class="flex items-center justify-center w-full max-w-xs"
      v-if="isLoading"
    >
      <bar-loader class="my-8" color="#4db1fa" :width="320" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { decode } from "js-base64";

export default {
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
  },
  methods: {
    ...mapActions("auth", ["loginWithSnapchat", "setTempSnapchatAccessToken"]),
    ...mapActions("profile", ["fetch"]),

    async SnapchatRedirect() {
      this.isLoading = true;

      try {
        if (!this.$route.query.length) {
          this.isLoading = false;
          this.$router.push({ name: "login" }).catch(() => {});
        }

        const isNewUser = parseInt(this.$route.query.isNewUser);
        const tempSnapchatAccessToken = this.$route.query.accessToken;

        await this.setTempSnapchatAccessToken(tempSnapchatAccessToken);

        if (isNewUser === 1) {
          return this.$router
            .push({ name: "account-confirmation" })
            .catch(() => {});
        }

        const token = decode(this.$route.query.token);
        // login with snapchat
        await this.loginWithSnapchat(token);
        if (this.isAuthenticated) {
          // Fetches the user profile
          await this.fetch();
        }

        this.$router.push({ name: "stations" }).catch(() => {});
      } catch (err) {
        this.$toasted.show(err.response.message, {
          type: "error",
          duration: 5000,
        });
        this.$router.push({ name: "login" }).catch(() => {});
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    setTimeout(async () => {
      await this.SnapchatRedirect();
    });
  },
};
</script>

<style></style>
